<template>
    <b-modal
        id="checkoutModal"
        v-model="schimbaModal"
        size="md"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body" style="min-height: 350px">
            <div class="close-button" @click="$emit('hideTempModal')">X</div>
            <div class="modal-header">
                <span style="cursor: pointer;">Schimbă compania</span>
            </div>
            <p>Alege o altă companie din contul tău pentru a continua scrierea proiectului.</p>
            <v-select
                v-model="companieSelect"
                class="changeCompany"
                dir="ltr"
                :options="companii"
                input-id="id_series"
                :clearable="false"
                item-text="name"
                item-value="value"
                label="name"
                placeholder="Alege o companie"
                @click="toggleOpen()"
            ></v-select>
            <div class="button-confirm" @click="changeCompany(companieSelect)">Confirmă schimbarea</div>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload} from 'bootstrap-vue';
    import vSelect from 'vue-select'
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            vSelect
        },
        props: {
            schimbaModal: {
                type: Boolean,
                default: false
            },
            companii: null,
            companieSelectata: null,
        },
        data() {
            return {
                companieSelect: null,
                openedSelect: false,
            };
        },
        watch: {
            companieSelectata(newValue, oldValue){
                if(newValue !== oldValue){
                    this.companieSelectata = newValue
                    this.companieSelect = this.companieSelectata;
                }
            }
        },
        mounted() {
        },
        methods: {
            changeCompany(event) {
                if(event && this.companieSelectata && event.id === this.companieSelectata.id){
                    this.$toast.error('Compania este deja selectată');
                } else{
                    this.$store.dispatch('pageLoading/setLoading', true)
                    this.$emit('hideTempModal');
                    this.$emit('changeCompany', this.companieSelect)
                    this.$store.dispatch('companyChanged/setChanged', true);
                }
            },
            toggleOpen() {
                this.openedSelect = this.openedSelect !== true;
            },
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
        },
    };
</script>

<style scoped>
.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.v-select >>> .vs__dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
}
.close-button{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.button-confirm{
    color: #fff;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    padding: 5px 10px;
    width: 50%;
}
.button-confirm:hover{
    background: #fff;
    color: #000;
    cursor: pointer;
}
.v-select{
    width: 100%;
    margin: 15px 0;
}
.v-select >>> .vs__dropdown-toggle{
    margin: 0;
    background: transparent;
    border: 1px solid #fff;
    border-radius: 4px;
    width: 100%;
    min-width: 170px;
    padding: 2px;
}
.v-select >>> .vs__selected-options{
    font-size: 14px;
    color: #fff;
    flex-wrap: inherit !important;
    max-height: 35px;
    overflow: hidden;
    align-items: flex-start;
}
.v-select >>> .vs__selected{
    margin: 0;
    padding: 0;
    color: #fff;
}
.v-select >>> .vs__actions{
    padding: 0;
    transform: scale(0.65);
}
.v-select >>> .vs__actions svg{
    color: #fff;
    fill: #fff;
}
.v-select >>> .vs__dropdown-menu{
    background: #343a40;
    font-size: 12px;
}
.v-select >>> .vs__dropdown-option{
    color: #fff;
}
.v-select >>> .vs__dropdown-option:hover{
    background: #545a6f;
}
.v-select >>> .vs__selected-options input{
    color: #fff;
}
</style>